import I18n from 'I18n';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CreditsExplainerHeader = () => {
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h2",
      "data-typography": "h4",
      marginBlockEnd: "200",
      children: I18n.text('hsocCreditsExplainer.header.title')
    }), /*#__PURE__*/_jsx(Text, {
      as: "strong",
      "data-typography": "h5",
      children: I18n.text('hsocCreditsExplainer.header.subtitle')
    }), /*#__PURE__*/_jsx(Text, {
      as: "p",
      "data-typography": "p-sm",
      marginBlockStart: "600",
      children: I18n.text('hsocCreditsExplainer.header.description')
    })]
  });
};
export default CreditsExplainerHeader;